import { useContext, useEffect, useRef } from 'react'
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import { CoordinateConverter } from '../../../../../util/coordinateConverter';
import {Color, Entity, CallbackProperty, Cartesian3, ArcType, Material, PolylineDashMaterialProperty} from 'cesium';

interface Props {
    pos: number[][];
    delay: number;
    roll: number;
    size: number;
    color: number[];
}

export default function TDOA(props: Props) {
    const viewer = useContext(CesiumViewerContext);
    const converter = new CoordinateConverter();
    const entityRef = useRef<Entity>();
    useEffect(() => {
        if (!viewer) {
            return () => { }
        }
        const posArray = converter.getHyperbola3DFilteredHeight(props.pos[0], props.pos[1], props.delay, props.roll, 1e6, 0, 8e5);
        
        if(posArray.length > 0) {
            const positions = new CallbackProperty(() => {
                return Cartesian3.fromDegreesArrayHeights(posArray);
            }, true)
            const material = Color.fromBytes(props.color[0], props.color[1], props.color[2], props.color[3]);
            const e = viewer.entities.add({
                polyline: {
                    width: props.size,
                    positions,
                    material,
                    arcType: ArcType.NONE
                }
            } as any);
            entityRef.current = e;
            return () => { viewer!.entities.remove(e) }
        }
    }, [viewer]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        const posArray = converter.getHyperbola3DFilteredHeight(props.pos[0], props.pos[1], props.delay, props.roll, 1e6, 0, 8e5);
        if(posArray.length > 0) {
            (entity as any).polyline.positions.setCallback(() => {
                return Cartesian3.fromDegreesArrayHeights(posArray);
            }, false);
        }
    }, [props.pos, props.delay, props.roll]);
    
    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).polyline.width.setValue(props.size);
    }, [props.size]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        const material = Color.fromBytes(props.color[0], props.color[1], props.color[2], props.color[3]);
        (entity as any).polyline.material = material;
    }, [props.color]);

    return null;
}
